import { NoInfer } from 'react-redux';

import { ActionReducerMapBuilder, Draft, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  FulfilledActionType,
  PendingActionType,
  RejectedActionType,
  errorOr,
  fulfilled,
  pending,
  rejected
} from 'store/storeHelpers';

import { BebyggelseobjektVersionHistorisk, ModelError, State } from 'models';
import { HTTP_STATUS } from 'models/appModels/Request';

import BebyggelseApi from 'api/bebyggelseApi';

export const getBebyggelseobjektVersion = createAsyncThunk<
  BebyggelseobjektVersionHistorisk,
  { id: string; version: number },
  { rejectValue: ModelError }
>('get/bebyggelseobjektversion', async ({ id, version }, { rejectWithValue }): Promise<any> => {
  const response: Response = await BebyggelseApi.bebyggelseobjekt.getVersion(id, version);
  return errorOr(response, rejectWithValue, [HTTP_STATUS.SERVICE_UNAVAILABLE]);
});

const initialState: State<BebyggelseobjektVersionHistorisk> = {
  requestStatus: 'idle',
  requestType: undefined,
  data: undefined,
  currentRequestId: undefined,
  error: undefined
};

const bebyggelseobjektVersionSlice = createSlice({
  name: 'bebyggelseobjektVersion',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<State<BebyggelseobjektVersionHistorisk>>>): void => {
    builder.addCase(
      getBebyggelseobjektVersion.pending,
      (state: Draft<State<BebyggelseobjektVersionHistorisk>>, action: PendingActionType): void => pending(state, action)
    );
    builder.addCase(
      getBebyggelseobjektVersion.fulfilled,
      (
        state: Draft<State<BebyggelseobjektVersionHistorisk>>,
        action: FulfilledActionType<BebyggelseobjektVersionHistorisk>
      ): void => fulfilled(state, action)
    );
    builder.addCase(
      getBebyggelseobjektVersion.rejected,
      (state: Draft<State<BebyggelseobjektVersionHistorisk>>, action: RejectedActionType): void =>
        rejected(state, action)
    );
  }
});

export default bebyggelseobjektVersionSlice.reducer;
